import React from 'react';

import { Formik, Form, Field, ErrorMessage } from 'formik';
import { StandardBlockWrapper } from './standardBlockWrapper';
import { useLocation } from '@reach/router';
import { motion } from 'framer-motion';

function encode(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
    .join('&');
}

const ContactForm = ({ heading, backgroundColor, padding }) => {
  const location = useLocation();
  return (
    <StandardBlockWrapper
      backgroundColor={backgroundColor}
      padding={padding}
      className="grid grid-cols-14"
    >
      <h2 className="text-left font-display text-4xl mb-10 col-start-2 col-end-14 lg:col-start-3 lg:col-end-13">
        {heading}
      </h2>
      <Formik
        initialValues={{
          firstName: '',
          surname: '',
          email: '',
          phone: '',
          message: '',
        }}
        validate={(values) => {
          const errors = {};
          if (!values.email) {
            errors.email = 'Required';
          } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            errors.email = 'Invalid email address';
          }
          if (!values.message) {
            errors.message = 'You must submit a message';
          }
          return errors;
        }}
        onSubmit={(values, { setSubmitting, setStatus }) => {
          fetch(location.pathname, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: encode({
              'form-name': `contact-form`,
              ...values,
            }),
          })
            .then(() => {
              setSubmitting(false);
              setStatus('success');
            })
            .catch((error) => alert(error));
        }}
      >
        {({
          onChange,
          isSubmitting,
          status,
          /* and other goodies */
        }) => (
          <Form
            className="col-start-2 col-end-14 lg:col-start-3 lg:col-end-13"
            name="contact-form"
            data-netlify="true"
            data-netlify-honeypot="bot-field"
            subject="Website Enquiry"
          >
            {/* Hidden Fields for netlify */}
            <input type="hidden" name="form-name" value="contact-form" />
            <p hidden>
              <label>
                <input name="bot-field" onChange={onChange} />
              </label>
            </p>
            {status === 'success' ? (
              <div className="col-span-full text-center">
                <motion.h2
                  className="font-display text-2xl"
                  initial={{ y: 20, opacity: 0 }}
                  animate={{ y: 0, opacity: 1 }}
                >
                  Thank you we will be in touch.
                </motion.h2>
              </div>
            ) : (
              <>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <Field
                      type="text"
                      name="firstName"
                      className="bg-sand px-4 py-4 w-full placeholder-marphonaText"
                      placeholder="First Name"
                    />
                  </div>
                  <div>
                    <Field
                      type="text"
                      name="surname"
                      className="bg-sand px-4 py-4 w-full placeholder-marphonaText"
                      placeholder="Surname"
                    />
                  </div>
                  <div>
                    <Field
                      type="email"
                      name="email"
                      className="bg-sand px-4 py-4 w-full placeholder-marphonaText"
                      placeholder="Email*"
                    />
                    <ErrorMessage name="email" component="div" />
                  </div>
                  <div>
                    <Field
                      type="phone"
                      name="phone"
                      className="bg-sand px-4 py-4 w-full placeholder-marphonaText"
                      placeholder="Phone Number"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <Field
                      type="textarea"
                      name="message"
                      className="bg-sand px-4 py-4 w-full placeholder-marphonaText"
                      placeholder="Message"
                      component="textarea"
                    />
                    <ErrorMessage name="message" component="div" />
                  </div>
                </div>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="font-display text-2xl ml-auto flex mt-8"
                >
                  Submit
                </button>
              </>
            )}
          </Form>
        )}
      </Formik>
    </StandardBlockWrapper>
  );
};

export default ContactForm;
